import React from 'react';
import { List } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import RequestLabelGroup from './RequestLabelGroup';

const RequestTags = ({
  code,
  category,
  value,
  type,
  isEditing,
  canEdit,
}) => (
  <>
    <List.Header className="mb-5">
      <FormattedMessage id={`request.list.${type}.title`} />
    </List.Header>
    {!isEditing && (
      <RequestLabelGroup
        code={code}
        category={category}
        labels={value}
        isEditing={isEditing}
        canEdit={canEdit}
      />
    )}
  </>
);

export default RequestTags;
